module.exports = __webpack_public_path__ + "static/media/Grupo20mg.a0614eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/Grupo20mg.png
// module id = 95
// module chunks = 0